export enum AnalyticsType {
  YA_METRIKA = "ya_metrika",
  VK_PIXEL = "vk_pixel",
  OWN_ANALYTICS = "own_analytics"
}